export interface AttachmentsResponseInterface {
  id: string;
  bucket_name: string;
  storage_path: string;
  public_url: string;
  file_type: string;
  file_size: number;
  file_name: string;
  status: AttachmentsStatus;
  created_at: string | null;
  updated_at: string | null;
}

export enum AttachmentsStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}
